import Vue from 'vue';
import * as Tone from 'tone';
import {Midi} from '@tonejs/midi';

Vue.prototype.$Tone = Tone;
Vue.prototype.$Midi = Midi;

// Object.defineProperty(Vue.prototype, '$Tone', { value: Tone });
